import { connect } from "react-redux";
import qs from "querystring";
import ExternalLogin from "./ExternalLogin";
import { RouteMap } from "../common/navigation/routeMap";
import { logoutIDP, authorizeUserSession } from "../../actions/loginActions";
import { upgradeUserSession } from "../../actions/ssoActions";
import { isExist,isMobileWebView } from "cxa-utils";

/**
 * # for SSO
 *
 * ## Scenario
 *   - Logout actions need to start before upgrade session
 *   - Do request upgrade user session
 *   - Upgrade session should be successful all the time
 *   - After then, request authorize user session
 *
 * ## Flow
 *   1. Logouts (request by API)
 *   2. Clear session on FE
 *   3. Upgrade user session
 *   4. Save session information on FE (bearer)
 *   5. Authorize user session
 */

const { CXAMain } = RouteMap;

const doRedirect = (sp, history) => {
  let ssoReturnUrl = CXAMain;

  try {
    if (sp === "1") {
      ssoReturnUrl = "/sso/idp/login-assert";
    } else {
      const url = sessionStorage.getItem("ssoReturnUrl");
      if (isExist(url)) {
        ssoReturnUrl = url;
      }
    }
  } finally {
    // APL-5005 - Prevent token to be removed upon redirection
    // so that the app can go to HRPortal with the token in redux
    const { userAgent } = window.navigator;
    if (isMobileWebView(userAgent) || ssoReturnUrl !== CXAMain) {
      // eslint-disable-next-line xss/no-location-href-assign
      location.href = ssoReturnUrl;
    } else {
      history.push(CXAMain);
    }
  }
};

const mapStateToProps = ({ login, sso }) => {
  const { isLogoutIDPFetching, isLogoutIDPFetched } = login;
  const { isUpgradeSessionFetching, isUpgradeSessionFetched } = sso;

  const isLogoutIDPNeverRequest = !isLogoutIDPFetching && !isLogoutIDPFetched;

  // NOTE: pretend upgrade session request always success (no error check)
  const isUpgradeSessionNeverRequest = !isUpgradeSessionFetching && !isUpgradeSessionFetched;

  return {
    allowToAccessOnce: isLogoutIDPNeverRequest && isUpgradeSessionNeverRequest,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    runSSOFlow: search => {
      const query = search.substring(1);
      const { nonce, requiresOAuth, sp } = qs.parse(query);
      const isRequiresOAuth = isExist(requiresOAuth) && requiresOAuth.toLowerCase() === "true";
      const loginMode = isRequiresOAuth ? "oauth" : "default";

      // step by step
      Promise.resolve(/* Readable */)
        .then(() => dispatch(logoutIDP()))
        .finally((/* Even if logout processes has been falied, ignore it */) => {
          Promise.resolve()
            .then(() => dispatch(upgradeUserSession(nonce)))
            .then(() => {
              // no use shop
              if (loginMode !== "normal") {
                return dispatch(authorizeUserSession());
              }

              return Promise.resolve();
            })
            .then(() => doRedirect(sp, props.history));
        });
    },
  };
};
const ExternalLoginContainer = connect(mapStateToProps, mapDispatchToProps)(ExternalLogin);

export default ExternalLoginContainer;



// WEBPACK FOOTER //
// ./components/login/ExternalLoginContainer.jsx